var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 79,
    height: 79,
    rx: 39.5,
    fill: "#EDF7F1",
    stroke: "#4B7C69"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.1657 47.6434L27.8441 41.3217C27.5297 41.0181 27.1087 40.8501 26.6717 40.8539C26.2347 40.8577 25.8167 41.033 25.5077 41.342C25.1987 41.651 25.0234 42.069 25.0196 42.506C25.0158 42.943 25.1838 43.364 25.4874 43.6784L32.9874 51.1784C33.2999 51.4908 33.7238 51.6663 34.1657 51.6663C34.6077 51.6663 35.0315 51.4908 35.3441 51.1784L53.6774 32.845C53.981 32.5307 54.149 32.1097 54.1452 31.6727C54.1414 31.2357 53.9661 30.8177 53.6571 30.5087C53.3481 30.1997 52.93 30.0244 52.493 30.0206C52.0561 30.0168 51.6351 30.1848 51.3207 30.4884L34.1657 47.6434Z",
    fill: "#4B7C69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheckmark);
export default __webpack_public_path__ + "static/media/GreenCheckmark.d165c03df43ab4c740914cdf4140a785.svg";
export { ForwardRef as ReactComponent };